export function conversionPoint(state) {
  return state.conversionPoint;
}
